"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LegendIcon = function LegendIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M4 5.5A1.5 1.5 0 1 1 2.5 4 1.502 1.502 0 0 1 4 5.5zM15 2V1H6v1zm0 4V5H6v1zm0 4V9H6v1zm0 4v-1H6v1zM1 3h3V0H1zm0 8h3V8H1zm2.822 4a.246.246 0 0 0 .216-.364l-1.392-2.55a.177.177 0 0 0-.312.002l-1.376 2.55a.246.246 0 0 0 .217.362z"
    }) : _react["default"].createElement("path", {
      d: "M4 5.5A1.5 1.5 0 1 1 2.5 4 1.502 1.502 0 0 1 4 5.5zm-1 0a.5.5 0 1 0-.5.5.5.5 0 0 0 .5-.5zM15 2V1H6v1zm0 4V5H6v1zm0 4V9H6v1zm0 4v-1H6v1zM.708 15l1.78-3.3L4.292 15zm2.333-.821l-.545-1-.538 1zM1 0h3v3H1zm2 2V1H2v1zM1 8h3v3H1zm2 2V9H2v1z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M5 9a2 2 0 1 1-2-2 2.003 2.003 0 0 1 2 2zm18-5V3H8v1zm0 6V9H8v1zm0 6v-1H8v1zm0 6v-1H8v1zM1 5h4V1H1zm0 12h4v-4H1zm3.685 6a.354.354 0 0 0 .31-.524l-1.84-3.368a.19.19 0 0 0-.334 0l-1.817 3.37a.354.354 0 0 0 .311.522z"
    }) : _react["default"].createElement("path", {
      d: "M5 9a2 2 0 1 1-2-2 2.003 2.003 0 0 1 2 2zM4 9a1 1 0 1 0-1 1 1 1 0 0 0 1-1zm19-5V3H8v1zm0 6V9H8v1zm0 6v-1H8v1zm0 6v-1H8v1zM.937 23L3 19.209 5.063 23zm2.443-1L3 21.301 2.62 22zM1 1h4v4H1zm3 3V2H2v2zm-3 9h4v4H1zm3 3v-2H2v2z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M11 6V5h18v1zm18 7v-1H11v1zm0 7v-1H11v1zm0 7v-1H11v1zM5.499 10A2.5 2.5 0 1 0 8 12.5 2.502 2.502 0 0 0 5.499 10zM3 8h5V3H3zm0 14h5v-5H3zm2.616 2.135a.246.246 0 0 0-.44.008l-2.158 4.505a.246.246 0 0 0 .221.352h4.522a.246.246 0 0 0 .217-.36z"
  }) : _react["default"].createElement("path", {
    d: "M11 6V5h18v1zm18 7v-1H11v1zm0 7v-1H11v1zm0 7v-1H11v1zM8 12.5A2.5 2.5 0 1 1 5.499 10 2.503 2.503 0 0 1 8 12.5zm-1 0A1.5 1.5 0 1 0 5.5 14 1.502 1.502 0 0 0 7 12.5zm.952 16.296H3.064l2.398-4.864zm-1.636-1L5.48 26.16l-.808 1.636zM3 3h5v5H3zm4 4V4H4v3zM3 17h5v5H3zm4 4v-3H4v3z"
  }));
};

var _default = LegendIcon;
exports["default"] = _default;